import 'firebase/messaging';
import create, { UseStore } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

import { environment } from '../../environments/environment';
import { getStoreName } from '../utils/functions';
import { UseFirebaseStore } from './models';
import { getFirebaseToken, initializeFirebase, setToken } from './services';

const defaultState = {
  messaging: null,
  serviceWorker: null,
}

export function createFirebaseStore(): UseStore<UseFirebaseStore> {
  return create<UseFirebaseStore>(
    persist(
      devtools((set, get) => ({
        token: null,
        ...defaultState,
        initializeFirebase: initializeFirebase(set, get),
        setToken: setToken(set, get),
        setServiceWorker: serviceWorker => set({ serviceWorker }),
        getFirebaseToken: getFirebaseToken(set, get),
      }), getStoreName('useFirebase')), {
        name: getStoreName('useFirebase'),
        version: environment.zustandStoreVersion,
        whitelist: ['token'],
        onRehydrateStorage: () => {
          return (savedState) => {
            savedState.setToken(savedState.token);
          }
        },
      }),
  );
}
